import { format, utcToZonedTime } from 'date-fns-tz';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { distinctUntilChanged } from 'rxjs';
import { selectUserInformation } from '../state/selectors/user-profile.selectors';

@Injectable({
  providedIn: 'root',
})
export class DateUtilities {
  userTimezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;

  constructor(store: Store<AppState>) {
    store
      .select(selectUserInformation)
      .pipe(distinctUntilChanged())
      //.pipe(take(1))
      .subscribe((data) => {
        console.log('retreived user timezone: ', data?.userTimeZoneName);
        this.userTimezone = data?.userTimeZoneName ?? this.userTimezone;
      });
  }

  formatToHHMMSS(hoursRaw) {
    let totalSeconds = hoursRaw * 3600;
    let hours = Math.floor(totalSeconds / 3600);
    let minutes = Math.round(Math.floor((totalSeconds - hours * 3600) / 60));
    let seconds = Math.round(totalSeconds - hours * 3600 - minutes * 60);
    let ampm = 'AM';

    if (hours >= 12) {
      hours = hours - 12;
      ampm = 'PM';
    }

    let hourStr = hours.toString();
    let minuteStr = minutes.toString();
    let secondStr = seconds.toString();

    if (hours > 0 && hours < 10) hourStr = '0' + hours;
    else if (hours === 0) hourStr = '12';

    if (minutes < 10) {
      minuteStr = '0' + minutes;
    }
    if (seconds < 10) {
      secondStr = '0' + seconds;
    }

    return hourStr + ':' + minuteStr + ':' + secondStr + ' ' + ampm;
  }

  formatUTCDateToMMddyyyyhhmmampm(
    date: Date | string | number | null | undefined,
    dateFormat?: string,
    timezone?: string,
  ): string {
    if (!date) return '';

    if (!dateFormat) dateFormat = 'MM/dd/yyyy hh:mm a';

    if (!timezone) timezone = this.userTimezone;

    // Convert your UTC date to the local timezone
    const zonedDate = utcToZonedTime(date, timezone);
    const formattedDate = format(zonedDate, dateFormat, { timeZone: timezone });
    return formattedDate;
  }


  formatUTCDateTohhmmampm(isoDate: Date): string {
    const dt = new Date(isoDate)
    if (!dt || dt == null) return '';

    let hours = dt.getHours();
    let minutes = ('0' + dt.getMinutes()).slice(-2);
    let ampm = hours >= 12 ? 'pm' : 'am';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const seperator = ':';
    return (hours + seperator + minutes + ' ' + ampm
    );
  }

  formatUTCDateToMMddyyyyhhmmampm_dayofweek(date: Date): string {
    return (
      this.formatUTCDateToMMddyyyyhhmmampm(date) +
      ' (' +
      this.getDayOfWeek(date) +
      ')'
    );
  }

  formatDateToMMddyyyyhhmmampm_dayofweek(datePassed: Date): string {
    const date = new Date(datePassed);
    return (
      format(date, 'MM/dd/yyyy hh:mm a') + ' (' + this.getDayOfWeek(date) + ')'
    );
  }

  getFileFormattedTimestamp(dt: Date): string {
    let year = dt.getFullYear();
    let month = ('0' + (dt.getMonth() + 1)).slice(-2); // Months are zero based
    let day = ('0' + dt.getDate()).slice(-2);
    let hours = dt.getHours();
    let minutes = ('0' + dt.getMinutes()).slice(-2);
    let ampm = hours >= 12 ? 'pm' : 'am';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const seperator = '_';
    return (
      year + seperator + month + seperator + day + seperator + hours + seperator + minutes + seperator + ampm
    );
  }

  getDayOfWeek(date) {
    const dayOfWeek = new Date(date).getDay();
    return isNaN(dayOfWeek)
      ? null
      : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][dayOfWeek];
  }
}

@Pipe({
  name: 'datetime',
})
export class DateTimePipe implements PipeTransform {
  transform(
    value: Date | string | number | null | undefined,
    datetimeFormat?: string,
    timezone?: string,
  ): string {
    return this.dateUtilities.formatUTCDateToMMddyyyyhhmmampm(
      value,
      datetimeFormat,
      timezone,
    );
  }

  constructor(private dateUtilities: DateUtilities) {}
}
